<ambita-cadastre-report-owners-subsection>
  <tr class="ambita-cadastre-report__row" each="{ owner in opts.owners }">
    <td>{ owner.organizationNumber || owner.personalNumber || owner.shortPersonalNumber }</td>
    <td>{ owner.birthday }</td>
    <td>{ owner.name }</td>
    <td>{ owner.fraction }</td>
    <td>{ getAddressFromOwner(owner) }</td>
    <td>{ owner.cadastreLevel }</td>
  </tr>
  <script>
    import { init } from '../sectionController';

    init(this);
  </script>
</ambita-cadastre-report-owners-subsection>
